var _excluded = ["variant", "color", "careVariant", "children", "href", "rel", "inline", "bold", "component"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles, Link as MuiLink } from '@material-ui/core';
import Typography from '../Typography';
var useStyles = makeStyles(function () {
  return {
    root: {
      fontWeight: 700
    },
    inline: {
      fontWeight: 400
    },
    bold: {
      '& .MuiTypography-root': {
        fontStyle: 'normal',
        fontWeight: 700
      }
    }
  };
});

var Link = function Link(props, ref) {
  var variant = props.variant,
      color = props.color,
      careVariant = props.careVariant,
      _props$children = props.children,
      children = _props$children === void 0 ? '' : _props$children,
      href = props.href,
      rel = props.rel,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      _props$bold = props.bold,
      bold = _props$bold === void 0 ? false : _props$bold,
      component = props.component,
      otherProps = _objectWithoutProperties(props, _excluded);

  var classes = useStyles();
  var root = bold && classes.bold || inline && classes.inline || classes.root;
  return React.createElement(MuiLink, _extends({
    ref: ref
  }, otherProps, {
    classes: {
      root: root
    },
    rel: rel,
    href: href || (!component ? '#' : undefined),
    component: component,
    underline: inline ? 'always' : 'none'
  }), React.createElement(Typography, {
    variant: variant,
    careVariant: careVariant,
    color: color,
    component: "span"
  }, children));
};

export default React.forwardRef(Link);
//# sourceMappingURL=Link.js.map